import moment from 'moment';
import { groups } from './devdata';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/employeeagreement';

export default {
  getById: (employeeId, year) => AppUsersClient.get(`${resource}/${employeeId}/${year}`),
  getAllForYear: (year) => AppUsersClient.get(`${resource}/getAllForYear/${year}`),
  update(agreement) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .put(`${resource}`, agreement)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateAll(agreements) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .put(`${resource}/updateAll`, agreements)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
